import { useQuery } from "@tanstack/react-query";
import { getDelayById } from "../../codes/repositories/ConfigurationDelayRepository";
import type { DelayByShift } from "../../delays-manager/models/DelayByShift";

export const useDelayByIdQuery = (delayId: number | null, enabled = true) => {
  return useQuery({
    queryKey: ["delay", delayId],
    queryFn: async ({ signal }) => {
      const resp = await getDelayById(delayId!, signal);
      if (resp.ok) {
        return resp.data as DelayByShift;
      }
      throw new Error(resp.message ?? "Failed to fetch delay");
    },
    enabled: enabled && !!delayId,
  });
};
